import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import {
    toggleTopControls,
    toggleLeftControls,
} from '../../../redux/diagram/diagram.actions';
import {
    selectIsControlsFocusMode,
    selectIsTopControlsHidden,
    selectIsLeftControlsHidden,
} from '../../../redux/diagram/diagram.selectors';

import * as Tooltip from '@radix-ui/react-tooltip';

import './ControlsFocusArrows.scss';

export const ControlsFocusArrows = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const isControlsFocusMode = useSelector(selectIsControlsFocusMode);
    const isTopControlsHidden = useSelector(selectIsTopControlsHidden);
    const isLeftControlsHidden = useSelector(selectIsLeftControlsHidden);

    if (!isControlsFocusMode) return null;

    return (
        <div className="controls_focus_arrows">

            <Tooltip.Root ignoreNonKeyboardFocus delayDuration={300} disableHoverableContent>
                <Tooltip.Trigger asChild>
                    <div
                        className={`focus-arrow focus-arrow-top ${isTopControlsHidden ? 'collapsed' : 'expanded'}`}>
                        <button
                            className="control-focus"
                            type="button"
                            onClick={() => dispatch(toggleTopControls())}
                        >
                            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M6 9l6 6 6-6" />
                            </svg>
                        </button>
                    </div>
                </Tooltip.Trigger>
                <Tooltip.Portal>
                    <Tooltip.Content
                        className="tooltip-content tooltip-controls wo-shortcut"
                        side="bottom"
                        align="center"
                        sideOffset={8}
                    >
                        <span>{isTopControlsHidden ? t('focus_controls.show_top') : t('focus_controls.hide_top')}</span>
                    </Tooltip.Content>
                </Tooltip.Portal>
            </Tooltip.Root>


            <Tooltip.Root ignoreNonKeyboardFocus delayDuration={300} disableHoverableContent>
                <Tooltip.Trigger asChild>
                    <div
                        className={`focus-arrow focus-arrow-left ${isLeftControlsHidden ? 'collapsed' : 'expanded'}`}
                    >
                        <button
                            className="control-focus"
                            type="button"
                            onClick={() => dispatch(toggleLeftControls())}
                        >
                            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M9 6l6 6-6 6" />
                            </svg>
                        </button>
                    </div>
                </Tooltip.Trigger>
                <Tooltip.Portal>
                    <Tooltip.Content
                        className="tooltip-content tooltip-controls wo-shortcut tooltip-back-link"
                        side="bottom"
                        align="center"
                        sideOffset={8}
                    >
                        <span>{isLeftControlsHidden ? t('focus_controls.show_left') : t('focus_controls.hide_left')}</span>
                    </Tooltip.Content>
                </Tooltip.Portal>
            </Tooltip.Root>

        </div>
    );
};

export default ControlsFocusArrows;
